module.exports = __webpack_public_path__ + "img/Southwest_Quinoa_2.df6163dc.jpg";